<template>
    <v-card>
        <v-img height="80" src="@/assets/images/fondo1.png">
            <v-row>
                <v-row class="pa-4" align="center" justify="center">
                    <v-col fluid>
                        <v-list-item-avatar color="indigo darken-2" size="40" class="ma-0">
                          <v-icon color="white" size="30">history_edu</v-icon>
                        </v-list-item-avatar>
                        <span class="headline black--text ma-4">LMS</span>
                    </v-col>
                </v-row>
            </v-row>
        </v-img>
        <v-tabs background-color="primary">
            <v-tab>Matriculas</v-tab>
            <v-tab>Secciones</v-tab>
            <v-tab>Bloquear</v-tab>
            <v-tab>Docentes</v-tab>
            <v-tab v-if="ssUser.Usuario=='larenas' || ssUser.Usuario=='cquispeh' || ssUser.Usuario=='yquispitupa' || ssUser.Usuario=='aflores' || ssUser.Usuario=='raportugal'">Test Docente</v-tab>
            <v-tab-item>
                <CLmsMatMatricula/>
            </v-tab-item>
            <v-tab-item>
                <CLmsMatSeccion/>
            </v-tab-item>
            <v-tab-item>
                <CPriAlumnosBloqueoDeudaForm/>
            </v-tab-item>
            <v-tab-item>
              <CLmsMatCargaDocente/>
            </v-tab-item>
            <v-tab-item>
              <CTestDocente/>
            </v-tab-item>
        </v-tabs>
    </v-card>    
</template>

<script>
import {mapState} from 'vuex';
import CLmsMatMatricula from '@/components/Lms/MatMatricula.vue'
import CLmsMatSeccion from '@/components/Lms/MatSeccion.vue'
import CPriAlumnosBloqueoDeudaForm from '@/components/Lms/PriAlumnosBloqueoDeudaForm.vue'
import CLmsMatCargaDocente from '@/components/Lms/MatCargaDocente.vue'
import CTestDocente from '@/components/Test/TestDocente.vue'

export default {
    name: 'Teams',
    components: {CLmsMatMatricula, CLmsMatSeccion, CPriAlumnosBloqueoDeudaForm, CLmsMatCargaDocente, CTestDocente},
    computed: {
        ...mapState(['ssUser']),
    },
}
</script>